/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import {Select,MenuItem,TextField,InputAdornment,} from '@mui/material';
import {Search} from 'lucide-react';

import AddIcon from '@mui/icons-material/Add';
import debounce from 'lodash.debounce';

import { Link as RouterLink } from 'react-router-dom';

import adminServices from '../../../services/adminServices';
import BasicModal from '../../../components/modal/BasicModel';
import CreateAdminForm from './CreateAdminForm';
import SnackBar from '../../../components/snackbar/snackbar';
import Modal from '../../../components/modal/Index';
import AddClientForm from './AddClientForm';
import Page from '../../../components/Page';
import ResponsiveTable from '../../../components/Table/Responsivetable';

export default function Client() {
  const [clientList, setClientList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [adminModalOpen, setAdminModalOpen] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteClientId, setDeleteClientId] = useState(null);
  const [deleteClientSlug, setDeleteClientSlug] = useState('');
  const [deleteClientIsFullCreator, setDeleteClientIsFullCreator] = useState(false);
  const [slugConfirmInput, setSlugConfirmInput] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [clientID, setClientID] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [mode, setMode] = useState('');
  const [clientId, setClientId] = useState(null);
  const [clientDetails, setClientDetails] = useState({});

  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [modeFilter, setModeFilter] = useState('all');
  const [page, setPage] = useState(0);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const addClientButton = () => {
    handleModalOpen(true);
    setMode('create');
  };

  const getClientInformation = async () => {
    try {
      const response = await adminServices.getClientInfo(clientId);
      if (response.ok) {
        setClientDetails(response.data);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const handleModalOpen = () => setModalOpen(true);

  const handleModalClose = () => {
    setModalOpen(false);
    setClientId(null);
    setPage(0);
  };

  const handleEditButton = (id) => {
    setMode('edit');
    setClientId(id);
    setModalOpen(true);
  };

  const handleClose = () => setAdminModalOpen(false);


  const snakbarHandle = (message) => {
    setOpenSnackbar(true);
    setSnackbarTitle(message);
  };

  const handleSearchChange = useCallback(
    debounce((searchText) => {
      setPage(0);
      getClientLists(0, searchText);
    }, 300),
    []
  );

  useEffect(() => {
    getClientInformation();
  },[clientId]);

  useEffect(() => {
    setPage(0);
    getClientLists(0);
  }, [statusFilter, modeFilter]);

  const getClientLists = async (currentPage = page, search = searchQuery) => {
    try {
      setLoading(true);
      const response = await adminServices.getClientList(currentPage, pageSize, search, statusFilter, modeFilter);

      if (response.ok) {
        const data = response.data?.data || response.data;
        const total = response.data?.total ?? 0;

        const transformedData = data.map(client => ({
          ...client,
          mode: client.featureToggleMode === 'FULL_CREATOR' ? 'Full Creator' : 'Run Only',
          licensedCategories: client.licensedCategories ||
            (client.subscriptionDetails ? client.subscriptionDetails.map(s => s.subscriptionName) .filter(Boolean) : []),
          seatsUsed: client.learnersCount || 0,
          seatsTotal: client.learnerSeats || 0,
          learnersCount: client.learnersCount || 0,
          addedDate: client.addedDate || client.createdDate || new Date().toISOString(),
          slug: client.slug || '',
          schemaName: client.schemaName || '',
          schemaStorage: client.schemaStorage || null,
        }));

        setClientList(transformedData);
        setTotalCount(total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDeleteModal = (row) => {
    setDeleteAlert(true);
    setDeleteClientId(row.id);
    setDeleteClientSlug(row.slug || '');
    setDeleteClientIsFullCreator(row.featureToggleMode === 'FULL_CREATOR');
    setSlugConfirmInput('');
  };

  const handleDelete = async () => {
    if (deleteClientIsFullCreator && slugConfirmInput !== deleteClientSlug) {
      setOpenSnackbar(true);
      setSnackbarTitle('Slug does not match. Please type the exact tenant slug to confirm deletion.');
      return;
    }
    try {
      setDeleteLoading(true);
      const data = await adminServices.deleteClientDetailsByID(deleteClientId, deleteClientSlug);
      if (data.ok) {
        setDeleteAlert(false);
        getClientLists();
        setOpenSnackbar(true);
        setSnackbarTitle(data.data.message);
      } else {
        setDeleteAlert(false);
        setOpenSnackbar(true);
        setSnackbarTitle(data.data.error || data.data.message || 'Delete failed');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const columns = [
    {
      key: 'organizationName',
      label: 'NAME',
      render: (row) => (
        <div>
          <div className="font-semibold text-gray-800 text-sm">
            {row.organizationName}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            Added {formatDate(row.addedDate)}
          </div>
        </div>
      ),
    },
    {
      key: 'mode',
      label: 'MODE',
      render: (row) => (
        <span
          className={`px-3 py-1 rounded-full text-xs font-medium ${row.mode === 'Full Creator'
            ? 'bg-blue-100 text-blue-600'
            : 'bg-gray-100 text-gray-500'
            }`}
        >
          {row.mode}
        </span>
      ),
    },
    {
      key: 'licensedCategories',
      label: 'LICENSED CATEGORIES',
      render: (row) => (
        <div className="flex flex-wrap gap-1">
          {row.licensedCategories?.map((cat) => (
            <span
              key={cat}
              className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded"
            >
              {cat}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: 'seats',
      label: 'SEATS',
      render: (row) => (
        <span className="text-sm font-medium text-gray-800">
          {row.seatsUsed} / {row.seatsTotal}
        </span>
      ),
    },
    {
      key: 'learnersCount',
      label: 'LEARNERS',
      render: (row) => (
        <span className="text-sm font-medium text-gray-800">
          {row.learnersCount}
        </span>
      ),
    },
    {
      key: 'status',
      label: 'STATUS',
      render: (row) => (
        <span
          className={`text-sm font-medium ${row.status === 'ACTIVE'
            ? 'text-green-500'
            : 'text-red-500'
            }`}
        >
          {row.status === 'ACTIVE' ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      key: 'actions',
      label: 'ACTIONS',
      render: (row) => (
        <div className="flex items-center gap-3">
          <RouterLink
            to={`/app/client-details`}
            state={{ from: row.id }}
            className="text-blue-600 font-medium text-sm hover:underline"
          >
            View
          </RouterLink>
          <button
            onClick={() => handleEditButton(row.id)}
            className="text-gray-600 font-medium text-sm hover:text-blue-600 hover:underline"
          >
            Edit
          </button>
          <button
            onClick={() => handleOpenDeleteModal(row)}
            className="text-red-500 font-medium text-sm hover:text-red-700 hover:underline"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <Page title="Client Admins">
      <div className="p-6 bg-gray-50 min-h-screen">

        <div className="text-sm mb-4 flex items-center gap-2 text-gray-500">
          <span className="text-gray-400">Super Admin</span>
          <span className="text-gray-300">›</span>
          <span className="text-gray-900 font-medium">Client Admins</span>
        </div>

        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-xl font-semibold text-gray-900">
              Client Admins
            </h1>
            <p className="text-sm text-gray-500">
              Manage B2B client organisations
            </p>
          </div>

          <button
            onClick={addClientButton}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center gap-2 text-sm font-medium"
          >
            <AddIcon fontSize="small" />
            Create Client Admin
          </button>
        </div>

        <div className="bg-white p-4 rounded-lg shadow-sm flex gap-4 mb-6 items-center">
          <TextField
            placeholder="Search tenants..."
            size="small"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              handleSearchChange(e.target.value);
            }} InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search className="text-gray-400" />
                </InputAdornment>
              ),
            }}
          />

          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            size="small"
          >
            <MenuItem value="all">All Status</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </Select>

          <Select
            value={modeFilter}
            onChange={(e) => setModeFilter(e.target.value)}
            size="small"
          >
            <MenuItem value="all">All Modes</MenuItem>
            <MenuItem value="FULL_CREATOR">Full Creator</MenuItem>
            <MenuItem value="RUN_ONLY">Run Only</MenuItem>
          </Select>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-4">
          <ResponsiveTable
            columns={columns}
            data={clientList}
            loading={loading}
            onActionClick={(action, row) => {
              if (action === 'edit') handleEditButton(row.id);
              if (action === 'delete') handleOpenDeleteModal(row);
            }}
            emptyStateComponent={() => (
              <div className="text-center py-10 text-gray-500">
                Sorry, there is no matching data to display
              </div>
            )}
          />
        </div>

        <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 mt-2">
          <span className="text-xs text-gray-500">
            Showing {page * pageSize + 1}–{Math.min((page + 1) * pageSize, totalCount)} of {totalCount}
          </span>
          <div className="flex gap-2">
            <button
              disabled={page === 0}
              onClick={() => { setPage(p => p - 1); getClientLists(page - 1); }}
              className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-gray-50"
            >
              Previous
            </button>
            <button
              disabled={(page + 1) * pageSize >= totalCount}
              onClick={() => { setPage(p => p + 1); getClientLists(page + 1); }}
              className="px-3 py-1 text-xs border border-gray-300 rounded disabled:opacity-40 hover:bg-gray-50"
            >
              Next
            </button>
          </div>
        </div>

        <BasicModal
          openModel={adminModalOpen}
          title="Add Client Admin"
          closeModel={() => setAdminModalOpen(false)}
        >
          <CreateAdminForm
            snackBarControl={snakbarHandle}
            getClientList={getClientLists}
            handleClose={handleClose}
            clientID={clientID}
          />
        </BasicModal>

        <Modal
          title={mode === 'create' ? 'Create Client Admin' : 'Edit Client Admin'}
          open={modalOpen}
          toggle={handleModalClose}
        >
          <AddClientForm
            mode={mode}
            clientId={clientId}
            clientDetails={clientDetails}
            getClientList={() => { setPage(0); getClientLists(0); }}
            toggle={handleModalClose}
            snackBarControl={snakbarHandle}
          />
        </Modal>

        {deleteAlert && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4">
              <h2 className="text-base font-semibold text-gray-900 mb-1">
                {deleteClientIsFullCreator ? 'Delete Tenant' : 'Delete Client'}
              </h2>
              {deleteClientIsFullCreator ? (
                <>
                  <p className="text-sm text-gray-500 mb-4">
                    This will permanently delete the tenant and drop the entire database schema
                    <span className="font-semibold text-gray-700"> ({deleteClientSlug})</span> including all its data.
                    This action cannot be undone.
                  </p>
                  <p className="text-sm text-gray-700 mb-2 font-medium">
                    Type the tenant slug <span className="font-mono bg-gray-100 px-1 rounded">{deleteClientSlug}</span> to confirm:
                  </p>
                  <input
                    type="text"
                    value={slugConfirmInput}
                    onChange={(e) => setSlugConfirmInput(e.target.value)}
                    placeholder={deleteClientSlug}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-red-400 mb-4"
                  />
                </>
              ) : (
                <p className="text-sm text-gray-500 mb-4">
                  Are you sure you want to delete this client? This action cannot be undone.
                </p>
              )}
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => { setDeleteAlert(false); setSlugConfirmInput(''); }}
                  className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  disabled={deleteLoading || (deleteClientIsFullCreator && slugConfirmInput !== deleteClientSlug)}
                  className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-40 flex items-center gap-2"
                >
                  {deleteLoading && (
                    <svg className="animate-spin w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                    </svg>
                  )}
                  {deleteClientIsFullCreator ? 'Delete Tenant' : 'Yes, Delete'}
                </button>
              </div>
            </div>
          </div>
        )}

        <SnackBar
          open={openSnackbar}
          snackbarTitle={snackbarTitle}
          close={() => setOpenSnackbar(false)}
        />
      </div>
    </Page>
  );
}
